import { withRouter } from 'react-router-dom';
import React from 'react';
import { connect } from 'react-redux';
import { doLogout } from '../actions/login';
import { Nav } from '../components/app/Nav';

const mapStateToProps = (state, props) => {
  let username = state?.auth?.loginUsername || '';
  let auth = state?.auth;
  let name = state?.lookup?.fullName || '';
  let bank = state?.lookup?.bank;
  let authenticated = state?.auth?.authenticated;

  return {
    ...auth,
    authenticated,
    username,
    name,
    isLogin: (props?.location?.pathname || '').includes('/login'),
    bank,
  };
};

const mapDispatchToProps = { logout: doLogout };

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Nav));
